/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { message, Select } from 'antd'
import { client } from '@utils/client'
import Modal from '@components/Modal'

import {
  babyWaitingApproveButton,
  babyWaitingApproveError,
  babyWaitingApproveModal,
} from './List'
import Text from '@components/Text'
import { ThemeContext } from '@contexts/ThemeContext'
import ErrorSvg from '@image/icons/ErrorSvg'
import { Button, Form, Input } from 'antd'
import dayjs from 'dayjs'
import nationalityOptions from '@utils/nationalityOptions'

const EditChild = (props) => {
  const { dataRecord, open, setOpen, reload } = props
  const { t } = useLocalization()
  const [modalConfirmEdit, setModalConfirmEdit] = useState(false)
  const [isKeyHn, setIsKeyHn] = useState(false)
  const [isKeyCitizenId, setIsKeyCitizenId] = useState(false)
  const [isKeyPassportId, setIsKeyPassportId] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const { theme } = useContext(ThemeContext)
  const [form] = Form.useForm()
  // const history = useHistory()
  // const params = useParams()

  useEffect(() => {
    resetField()
    setSearchValue(dataRecord.profile.nationality)
    form.setFieldsValue({
      nationality: dataRecord.profile.nationality,
    })

    if (dataRecord.profile.hn) {
      setIsKeyHn(true)
      form.setFieldsValue({
        hn: dataRecord.profile.hn,
      })
    }

    if (dataRecord.profile.citizenId) {
      setIsKeyCitizenId(true)
      form.setFieldsValue({
        citizenId: dataRecord.profile.citizenId,
      })
    }

    if (dataRecord.profile.passportId) {
      setIsKeyPassportId(true)
      form.setFieldsValue({
        passportId: dataRecord.profile.passportId,
      })
    }
  }, [dataRecord])

  const handleSubmit = async (data) => {
    const { hn, citizenId, passportId } = data
    try {
      await client.patch(`/profiles/kid/${dataRecord.profileId}`, {
        nationality: searchValue,
        hn: hn || null,
        citizenId: citizenId || null,
        passportId: passportId || null,
      })
      message.success('สำเร็จ')
      reload()
      setOpen(false)
    } catch (e) {
      let messageError =
        e && e.response && e.response.data && e.response.data.message
      if (messageError === 'Citizen ID already exists.') {
        messageError = t('messageEerror.citizenId')
      }
      if (messageError === 'HN already exists.') {
        messageError = t('messageEerror.hn')
      }
      if (messageError === 'Passport ID already exists.') {
        messageError = t('messageEerror.passportId')
      }
      message.error(messageError || 'ไม่สำเร็จ')
    }
  }

  const resetField = () => {
    setIsKeyHn(false)
    setIsKeyCitizenId(false)
    setIsKeyPassportId(false)
    form.setFieldsValue({
      citizenId: null,
      passportId: null,
      hn: null,
    })
  }
  const validateThaiCitizenId = (value) => {
    if (!/^\d+$/.test(value)) {
      return 'ต้องเป็นตัวเลขเท่านั้น'
    }

    if (value.length !== 13) {
      return 'ต้องมีความยาว 13 หลัก'
    }

    const id = value.split('').map(Number)
    const sum = id
      .slice(0, 12)
      .reduce((acc, digit, i) => acc + digit * (13 - i), 0)
    const checkDigit = (11 - (sum % 11)) % 10

    return checkDigit !== id[12] ? 'เลขบัตรประชาชนไม่ถูกต้อง' : null
  }

  /**
   * @type {{
   * footer: React.CSSProperties,
   * body: React.CSSProperties,
   * bodyConfirm: React.CSSProperties,
   * input: React.CSSProperties,
   * row: React.CSSProperties,
   * col: React.CSSProperties,
   * btn: React.CSSProperties }}
   */

  const style = {
    body: { display: 'flex', flexDirection: 'column', gap: 10 },
    bodyConfirm: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: 16,
    },
    footer: {
      display: 'flex',
      justifyContent: 'center',
      gap: 16,
    },
    input: { width: '100%', borderRadius: '8px', height: '40px' },
    btn: {
      borderRadius: '8px',
      width: '170px',
      height: '40px',
      fontWeight: '600',
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      gap: 16,
    },
    col: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      gap: 4,
    },
    list: {
      width: 170,
    },
  }

  return (
    <>
      <Modal
        centered={true}
        open={open}
        onCancel={() => setOpen(false)}
        closable={false}
        maskClosable={false}
        // footer={null}
        width={500}
        bodyStyle={{ padding: 16, overflowY: 'hidden' }}
      >
        <div style={style.body}>
          <Text level={1} strong>
            {t(`${babyWaitingApproveModal}.editChild`)}
          </Text>

          <div style={style.row}>
            <div style={style.list}>
              <Text level={3} color={theme.text.darkGrey}>
                {t(`${babyWaitingApproveModal}.childFullName`)} :
              </Text>
            </div>
            <div style={{ flex: 1 }}>
              <Text level={3} color={theme.text.black}>
                {dataRecord.profile.name}
              </Text>
            </div>
          </div>

          <div style={style.row}>
            <div style={style.list}>
              <Text level={3} color={theme.text.darkGrey}>
                {t(`${babyWaitingApproveModal}.parentFullName`)} :
              </Text>
            </div>
            <div style={{ flex: 1 }}>
              <Text level={3} color={theme.text.black}>
                {dataRecord.observer.profile.name}
              </Text>
            </div>
          </div>

          <div style={style.row}>
            <div style={style.list}>
              <Text level={3} color={theme.text.darkGrey}>
                {t(`${babyWaitingApproveModal}.createdDate`)} :
              </Text>
            </div>
            <div style={{ flex: 1 }}>
              <Text level={3} color={theme.text.black}>
                {dayjs(dataRecord.profile.createdAt).format('DD MMM YYYY')}
              </Text>
            </div>
          </div>

          <div style={style.row}>
            <div style={style.list}>
              <Text level={3} color={theme.text.darkGrey}>
                {t(`${babyWaitingApproveModal}.createdTime`)} :
              </Text>
            </div>
            <div style={{ flex: 1 }}>
              <Text level={3} color={theme.text.black}>
                {dayjs(dataRecord.profile.createdAt).format('HH:mm')}
              </Text>
            </div>
          </div>

          <Form
            layout="vertical"
            form={form}
            name="HNForm"
            onFinish={handleSubmit}
            requiredMark={false}
            style={{ width: '100%', paddingTop: 5 }}
          >
            <div style={style.col}>
              <Text level={3} color={theme.text.black}>
                {t(`${babyWaitingApproveModal}.nationality`)}
              </Text>
              <Form.Item name="nationality">
                <Select
                  size="large"
                  options={nationalityOptions}
                  placeholder="Select nationality"
                  value={searchValue || undefined}
                  onSearch={(value) => setSearchValue(value)}
                  onChange={(value) => {
                    setSearchValue(value || '')

                    resetField()
                  }}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  showSearch
                  virtual={false}
                />
              </Form.Item>
            </div>
            <div style={style.row}>
              <div style={style.col}>
                <Text level={3} color={theme.text.black}>
                  Hospital No.
                </Text>

                <Form.Item
                  name="hn"
                  // label="Hospital No."
                  rules={[
                    {
                      validator(_, value) {
                        const citizenId = form.getFieldValue('citizenId')
                        const passportId = form.getFieldValue('passportId')
                        const isNumberOnly = /^\d+$/.test(value)
                        if (value && !isNumberOnly) {
                          return Promise.reject(
                            new Error('HN. ต้องเป็นตัวเลขเท่านั้น')
                          )
                        }

                        if (value || citizenId || passportId) {
                          return Promise.resolve()
                        }
                        return Promise.reject(
                          new Error(
                            `${t(
                              `${babyWaitingApproveError}.pleaseEnter`
                            )} HN. หรือ ${
                              searchValue === 'thai'
                                ? 'Citizen ID'
                                : 'Passport ID'
                            } `
                          )
                        )
                      },
                    },
                  ]}
                >
                  <Input
                    style={style.input}
                    disabled={isKeyCitizenId || isKeyPassportId}
                    onChange={(e) => {
                      setIsKeyHn(e.target.value ? true : false)
                      form.validateFields()
                    }}
                  />
                </Form.Item>
              </div>
              {searchValue === 'thai' ? (
                <div style={style.col}>
                  <Text level={3} color={theme.text.black}>
                    Citizen ID
                  </Text>

                  <Form.Item
                    name="citizenId"
                    rules={[
                      {
                        validator(_, value) {
                          const hospitalNo = form.getFieldValue('hn')
                          const isNumberOnly = /^\d+$/.test(value)

                          if (value) {
                            const error = validateThaiCitizenId(value)
                            if (error) {
                              return Promise.reject(
                                new Error(`Citizen ID ${error}`)
                              )
                            }
                          }

                          if (value && !isNumberOnly) {
                            return Promise.reject(
                              new Error('Citizen Id. ต้องเป็นตัวเลขเท่านั้น')
                            )
                          }
                          if (value || hospitalNo) {
                            return Promise.resolve()
                          }
                          return Promise.reject(new Error(` `))
                        },
                      },
                    ]}
                  >
                    <Input
                      maxLength={13}
                      style={style.input}
                      disabled={isKeyHn}
                      onChange={(e) => {
                        setIsKeyCitizenId(e.target.value ? true : false)
                        form.validateFields()
                      }}
                    />
                  </Form.Item>
                </div>
              ) : (
                <div style={style.col}>
                  <Text level={3} color={theme.text.black}>
                    Passport ID
                  </Text>

                  <Form.Item
                    name="passportId"
                    rules={[
                      {
                        validator(_, value) {
                          const hospitalNo = form.getFieldValue('hn')
                          if (value || hospitalNo) {
                            return Promise.resolve()
                          }
                          return Promise.reject(new Error(` `))
                        },
                      },
                    ]}
                  >
                    <Input
                      style={style.input}
                      disabled={isKeyHn}
                      onChange={(e) => {
                        setIsKeyPassportId(e.target.value ? true : false)
                        form.validateFields()
                      }}
                    />
                  </Form.Item>
                </div>
              )}
            </div>
          </Form>
        </div>
        <div style={style.footer}>
          <Button
            key="cancel"
            onClick={() => {
              setModalConfirmEdit(true)
            }}
            style={style.btn}
          >
            <Text level={3} color={theme.text.darkGrey} semi>
              {t(`${babyWaitingApproveButton}.cancel`)}
            </Text>
          </Button>
          <Button
            type="primary"
            key="save"
            onClick={() => form.submit()}
            style={style.btn}
          >
            <Text level={3} color={theme.text.white} semi>
              {t(`${babyWaitingApproveButton}.save`)}
            </Text>
          </Button>
        </div>
      </Modal>

      <Modal
        centered={true}
        open={modalConfirmEdit}
        onCancel={() => setModalConfirmEdit(false)}
        closable={false}
        maskClosable={false}
        // footer={null}
        width={420}
        bodyStyle={{ padding: 40, overflowY: 'hidden', gap: 24 }}
      >
        <div style={style.bodyConfirm}>
          <ErrorSvg width={72} height={86} />
          <Text level={1} type="danger" bold>
            {t(`${babyWaitingApproveModal}.cancelEditConfirm`)}
          </Text>
          <Text
            level={3}
            bold
            color={theme.text.black}
            style={{ textAlign: 'center' }}
          >
            {t(`${babyWaitingApproveModal}.unsavedChangesWarning`)}
          </Text>
        </div>

        <div style={style.footer}>
          <Button
            key="editWarning"
            onClick={() => {
              setModalConfirmEdit(false)
            }}
            style={style.btn}
          >
            <Text level={3} color={theme.text.darkGrey} semi>
              {t(`${babyWaitingApproveButton}.back`)}
            </Text>
          </Button>
          <Button
            type="danger"
            key="editConfirm"
            onClick={() => {
              setOpen(false)
            }}
            style={style.btn}
          >
            <Text level={3} color={theme.text.white} semi>
              {t(`${babyWaitingApproveButton}.confirm`)}
            </Text>
          </Button>
        </div>
      </Modal>
    </>
  )
}

EditChild.propTypes = {
  reload: PropTypes.func,
  setOpen: PropTypes.func,
  open: PropTypes.bool,
  dataRecord: PropTypes.object,
}

export default EditChild
